import { toast } from "react-toastify";
import { amdinAccount, chainID } from "../../config/config";

export const onHandleNFTMarketMultipleIssueAction = async(keychain, nftInfo, username, symbolNft) => {
    console.log('[debug] onHandleNFTMarketMultipleIssueAction', nftInfo, username);
    let toAccount = nftInfo.toAccount ?? amdinAccount;

    let instances = [];
    let data = [];
    let countIssue = Math.floor(nftInfo.count / 10);
    let lastCountIssue = nftInfo.count % 10;

    if (countIssue > 1) {
        for (let j = 0; j < countIssue; j ++) {  
            let instances10 = [];          
            for(let i = 0; i < 10; i++) {
                instances10.push({
                    // "fromType": "user",
                    "symbol": symbolNft,
                    "to": toAccount,
                    "feeSymbol": "BEE",
                    "properties": {
                        name : nftInfo.name,
                        schema : nftInfo.schema,
                        img: nftInfo.img,
                        description: nftInfo.description,
                    }
                })
            }
        
            let issue10Nft = {
                "contractName": "nft",
                "contractAction": "issueMultiple",
                "contractPayload": {
                    "instances": instances10
                },
                "memo": "multiple issue for " + toAccount 
            };
            
            data.push(issue10Nft);
        }

        if (lastCountIssue > 0) {
            let instances_t = [];          
            for(let i = 0; i < lastCountIssue; i++) {
                instances_t.push({
                    // "fromType": "user",
                    "symbol": symbolNft,
                    "to": toAccount,
                    "feeSymbol": "BEE",
                    "properties": {
                        name : nftInfo.name,
                        schema : nftInfo.schema,
                        img: nftInfo.img,
                        description: nftInfo.description,
                    }
                })
            }
        
            let issueNft_t = {
                "contractName": "nft",
                "contractAction": "issueMultiple",
                "contractPayload": {
                    "instances": instances_t
                },
                "memo": "multiple issue for " + toAccount 
            };
            
            data.push(issueNft_t);
        } 
    } else {
        for(let i = 0; i < nftInfo.count; i++) {
            instances.push({
                // "fromType": "user",
                "symbol": symbolNft,
                "to": toAccount,
                "feeSymbol": "BEE",
                "properties": {
                    name : nftInfo.name,
                    schema : nftInfo.schema,
                    img: nftInfo.img,
                    description: nftInfo.description,
                }
            })
        }
    
        data = {
            "contractName": "nft",
            "contractAction": "issueMultiple",
            "contractPayload": {
                "instances": instances
            },
            "memo": "multiple issue for " + toAccount 
        };
    }

    console.log('issue payload data', data);
    
    try {
      keychain.requestCustomJson(username, chainID, "Active", JSON.stringify(data), "Issue multiple NFT", function(response) {
          if (response.success && response.result) {
              //show modal
              toast.success('NFT issue success!');
          } else {
              //show modal
              toast.error('Oops, something went wrong issuing the NFTs!');
              console.error('Custom Json failed:', { response });
          }
      });
    } catch (err) {
      console.error('Caught error in requestCustomJson:', err);
      toast.error('Something broke while issuing the NFTs!');
    }
};
